import { render, staticRenderFns } from "./TapCoinResult.vue?vue&type=template&id=5797f89d&scoped=true&"
import script from "./TapCoinResult.vue?vue&type=script&lang=js&"
export * from "./TapCoinResult.vue?vue&type=script&lang=js&"
import style0 from "./TapCoinResult.vue?vue&type=style&index=0&id=5797f89d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5797f89d",
  null
  
)

export default component.exports